import { render, staticRenderFns } from "./sortTemplate.vue?vue&type=template&id=5baab49b&"
import script from "./sortTemplate.vue?vue&type=script&lang=js&"
export * from "./sortTemplate.vue?vue&type=script&lang=js&"
import style0 from "./sortTemplate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports